import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Home from '@/pages/home';
import DeliverabilityHubPage from '@/pages/deliverability-hub';
import DeliverabilityOpsToolPage from '@/pages/deliverability-ops-tool';

export default function Routes() {
  return (
    <Switch>
      <Route exact path="/" component={Home} />
      <Route exact path="/deliverability-hub" component={DeliverabilityHubPage} />
      <Route exact path="/deliverability-ops-tool" component={DeliverabilityOpsToolPage} />
    </Switch>
  );
}
